import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class TablePreviewModel extends ModeModelBase {
  override _name = 'preview';
  override belongsTo = 'table';
  override attributes = [
    { name: 'name', default: '' },
    { name: 'schema', default: '' },
    { name: 'created_at', default: '' },
    { name: 'columns', default: [] },
    { name: 'content', default: [] },
  ];
}

@Injectable({ providedIn: 'root' })
export class TablePreviewModelAccessor extends ModelAccessorBase<TablePreviewModel> {
  override name = 'preview';
  override parentModel = 'table';
  override createModel(resource, opts?) {
    const model = new TablePreviewModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.preview');
  }
}
